import React from "react";

type MastercardColorProps = React.SVGProps<SVGSVGElement>;

const MastercardColor: React.FC<MastercardColorProps> = (props) => (
  <svg viewBox="0 0 120 80" role="img" fill="none" {...props}>
    <title>Mastercard</title>
    <rect width="120" height="80" rx="4" fill="#000000" />
    <g transform="translate(22,10)">
      <polygon fill="#FF5F00" points="28.014 42.573 48.709 42.573 48.709 5.383 28.014 5.383" />
      <path
        fill="#EB001B"
        d="M29.328,23.979 C29.328,16.434 32.86,9.714 38.361,5.383 C34.339,2.216 29.262,0.327 23.744,0.327 C10.682,0.327 0.094,10.916 0.094,23.979 C0.094,37.041 10.682,47.63 23.744,47.63 C29.262,47.63 34.339,45.741 38.361,42.574 C32.86,38.243 29.328,31.523 29.328,23.979"
      />
      <path
        fill="#F79E1B"
        d="M76.629,23.979 C76.629,37.041 66.041,47.63 52.979,47.63 C47.461,47.63 42.384,45.741 38.361,42.574 C43.863,38.243 47.395,31.523 47.395,23.979 C47.395,16.434 43.863,9.714 38.361,5.383 C42.384,2.216 47.461,0.327 52.979,0.327 C66.041,0.327 76.629,10.916 76.629,23.979"
      />
    </g>
  </svg>
);

export default MastercardColor;
